<template>
  <v-form
    ref="form"
    v-model="validForm"
    lazy-validation
  >
    <v-card
      max-width="600px"
      class="mx-auto"
      outlined
    >
      <v-card-title class="pa-10">
        <v-row class="mx-0">
          <h1 class="headline font-weight-medium">
            Edit Content
          </h1>
        </v-row>
        <v-spacer />
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-col cols="12">
            <v-text-field
              v-model="editedContent.title"
              :rules="[rules.required]"
              :hint="isWelcomeNote ? 'The user’s display name will appear after this title' : ''"
              label="Screen Title"
              placeholder="Screen Title"
              prepend-icon="mdi-format-title"
              class="headline"
              persistent-hint
            />

            <br>

            <template v-if="isWelcomeNote">
              <v-textarea
                v-model="editedContent.welcomeText"
                label="Welcome Text"
                auto-grow
                prepend-icon="mdi-subtitles-outline"
              />

              <v-text-field
                v-model="editedContent.shannonName"
                label="Shannon Name"
                prepend-icon="mdi-account-circle-outline"
              />

              <v-text-field
                v-model="editedContent.shannonTitle"
                label="Shannon Title"
                prepend-icon="mdi-account-badge-outline"
              />

              <br>

              <ImageUpload
                @setImgFields="setShannonImg"
                :editedItem="editedContent"
                :imgUrl="editedContent.shannonImgUrl"
                label="Shannon Image"
              />

              <ImageUpload
                @setImgFields="setSignatureImg"
                :editedItem="editedContent"
                :imgUrl="editedContent.signatureImgUrl"
                label="Shannon Signature"
              />
            </template>

            <v-container v-else>
              <br>
              <h3>Item 1</h3>
              <br>

              <ImageUpload
                @setImgFields="setItem1Img"
                :editedItem="editedContent"
                :imgUrl="editedContent.itemIcon1"
                label="Icon"
              />

              <v-textarea
                v-model="editedContent.itemText1"
                :counter="itemTextLimit"
                :maxlength="itemTextLimit"
                label="Text"
                prepend-icon="mdi-text-short"
                auto-grow
              />

              <br><br>

              <h3>Item 2</h3>
              <br>

              <ImageUpload
                @setImgFields="setItem2Img"
                :editedItem="editedContent"
                :imgUrl="editedContent.itemIcon2"
                label="Icon"
              />

              <v-textarea
                v-model="editedContent.itemText2"
                :counter="itemTextLimit"
                :maxlength="itemTextLimit"
                label="Text"
                prepend-icon="mdi-text-short"
                auto-grow
              />
            </v-container>
          </v-col>

          <br><br>

          <v-card-actions>
            <v-spacer />
            <v-btn @click="clearChanges" text>
              Clear Changes
            </v-btn>
            <v-btn
              @click="updateContent"
              color="primary"
              depressed
            >
              Update
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-card-text>
    </v-card>
  </v-form>
</template>

<script>
import BaseForm from './BaseForm';
import { ImageUpload } from 'components';

export default {
  name: 'ContentForm',

  components: {
    ImageUpload,
  },

  extends: BaseForm,

  props: {
    editedContent: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      itemTextLimit: 120,
    };
  },

  computed: {
    isWelcomeNote() {
      return this.editedContent.id === 'welcome-note';
    },
  },

  methods: {
    updateContent() {
      if (this.invalidForm) { return; }
      this.$emit('update-content');
    },

    setShannonImg(response) {
      this.editedContent.shannonImgUrl = response.secure_url;
    },

    setSignatureImg(response) {
      this.editedContent.signatureImgUrl = response.secure_url;
    },

    setItem1Img(response) {
      this.editedContent.itemIcon1 = response.secure_url;
    },

    setItem2Img(response) {
      this.editedContent.itemIcon2 = response.secure_url;
    },
  },
};
</script>
